
// Author: Sri Pooja
import { addcomp, delcomp } from './utilities'

/**
 * Reducer function for the header state.
 *
 * @param {Object} state - The current state.
 * @param {Object} action - The action object.
 * @returns {Object} - The new state.
 */
const headerReducer = (state = null, action) => {
    const items = action.message
    switch (action.type) {
        case 'HEADER_STATUS_SAVE':
            // Update the header state with the new items
            return { ...state, ...items }
        case 'HEADER_STATUS_DEL':
            // Delete a component from the header state
            return { ...state, components: delcomp(state.components, items) }
        case 'HEADER_STATUS_ADD':
            // Add a new component to the header state
            return { ...state, components: addcomp(state.components, items) }
        case 'HEADER_STATUS_UPDATE':
            // Placeholder case, no action needed
            return { ...state }
        case 'NOTIFICATIONS':
            // Update the header state with new notifications
            return { ...state, notifications: action.notifications }
        case 'OPEN_TOUR':
            // Update the header state to indicate that the tour is open
            return { ...state, isTourOpen: action.isTourOpen }
        case 'CLOSE_TOUR':
            // Update the header state to indicate that the tour is closed
            return { ...state, isTourOpen: action.isTourOpen }
        case 'WORKFLOW_RELOAD':
            // Update the header state with the workflow reload status
            return { ...state, workflowreload: action.workflowreload }
        case 'RECORDS_PREVVALUE':
            // Update the header state with the previous value of records
            return { ...state, recordssetvalue: action.recordssetvalue }
        case 'UNSAVED_DATA':
            // Update the header state with unsaved data and initial data
            return { ...state, unsaveddata: action.unsaveddata, initialdata: action.initialdata }
        case 'PROJMESSAGES':
            // Update the header state with project messages
            let messages = {}
            action.projmessages.forEach(e => messages[e.Key] = e.Message)
            return { ...state, projmessages: messages }
        case 'PASSTAB_DATA':
            // Update the header state with pass tab data and initial data
            return { ...state, passtabdata: action.passtabdata, initialdata: action.initialdata }
        case 'RECORD_DATA':
            // Update the header state with record ID info and record data
            return { ...state, recordidinfo: action.recordidinfo, recorddata: action.recorddata }
        case 'RESET_VALUES':
            // Update the header state to reset values
            return { ...state, resetval: action.isreset }
        case 'RUNHOLDVALS':
            // Update the header state with run hold values
            return { ...state, runholdvals: action.runholdvals }
        case 'ONEVENT_STATUS_TRANS':
            // Update the header state with on event transition status
            return { ...state, onEventTransition: action.onEventTransition }
        case 'ONEVENT_SHOW_ERRORS':
            // Update the header state with on event show error status
            return { ...state, onEventshowError: action.onEventshowError }
        case 'SITEPERMITTYPE_STATUS':
            // Update the header state with site permit types status
            return { ...state, SitePermitTypesStatus: action.SitePermitTypesStatus }
        case 'TRIGGER_AFTER_SAVE':
            // Update the header state with trigger after save status
            return { ...state, onTriggerSave: action.onTriggerSave }
        case 'SITE_PERMIT_TYPE_STATUS':
            return { ...state, onSitePermitTypesStatus: action.onSitePermitTypesStatus }
        case 'LEFTMENUDRAWER':
            // Update the header state with left menu drawer status
            return { ...state, leftmenuDrawer: action.leftmenuDrawer }
        case 'MOVEBARTOTOP':
            // Update the header state with move bar to top status
            // console.log(action.movebartotop, " action.movebartotop")
            return { ...state, movebartoTop: action.movebartoTop }
        case 'EXTRAPROPS_WORKFLOW':
            // Update the header state with extra props workflow status
            return { ...state, extrapropsworkflow: action.extrapropsworkflow }
        case 'WORKFLOW_APPROVER':
            // Update the header state with workflow approver status
            return { ...state, workflowApprover: action.workflowApprover }
        case 'SAVEWORKFLOWSTATUS':
            // Update the header state with save workflow status
            return { ...state, saveWorkflowStatus: action.saveWorkflowStatus }
        case 'RUNAFTERPROMISECORE':
            // Update the header state with run after promise core status
            return { ...state, runAfterPromiseCore: action.runafterpromise }
        case 'SELECTED_GRID_ROWS':
            return { ...state, selectedGridRows: action.selectedGridRows }
        case 'SHOW_UNSAVE_ALERT':
            return { ...state, showUnSaveAlert: action.showUnSaveAlert }
        default:
            return state

    }
}

export default headerReducer